<template>
  <Dialog title="收藏" class="cusBody" width="980px" top="8vh" :modal="true" :visible.sync="status" @closed="onClose">
    <div class="flex-v">
      <!-- <HeaderNav :posNavs="posNavs" /> -->
      <div class="flex">
        <!-- <Sider :type="2"></Sider> -->
        <div class="layout-right pd hideScrollbar" style="width: 100%;">
          <ScrollBar v-if="loaded && list.length" ref="scrollbar" class="scrollbar main">
            <div class="fav-box">
              <dl @click="jumpPage('book_detail', { id: item.bookId })" v-for="(item, index) in list" :key="index">
                <dt>
                  <img :src="item.book && item.book.coverUrl">
                  <div class="icon-box" @click.stop="onDel(item)">
                    <i class="icon icon-del"></i>
                  </div>
                </dt>
                <dd>{{ item.book && item.book.name }}</dd>
              </dl>
            </div>
          </ScrollBar>
          <div class="fav-nodata" v-if="loaded && (!list || !list.length)">
            <div class="no-data">
              <i class="icon icon-empty"></i>
              <div class="tip">您还没有收藏过专辑或专题</div>
              <button class="btn btn-go" @click.stop="jumpPage('book_library')">查看诵读资源</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { Dialog, MessageBox } from "element-ui";

export default {
  components: { Dialog },
  data() {
    return {
      posNavs: [],
      list: [],
      loaded: 0,
      pageIndex1: 1,
      pageSize: -1,
      status: false,
      isRefresh: false
    }
  },
  // created() {
  //   this.init();
  // },
  methods: {
    init() {
      this.setPosNav();
      this.getList();
      this.status = true;
    },
    async getList() {
      this.$loading.show();
      let params = {
        pageIndex: this.pageIndex1,
        pageSize: this.pageSize
      }
      const res = await this.$post('/book/favorite/list.json', params);
      if (res.status == 200) {
        let list = res.data.list || [];
        list = this.$getBookListImg(list)
        this.list = list;
      }
      this.loaded = 1;
      this.$loading.hide();
    },
    async deleteFav(item) {
      if (!item.book) {
        return;
      }
      let url = '/book/unfavorite.json';
      const res = await this.$post(url, {
        bookId: item.bookId
      });
      if (res.status == 200) {
        this.pageIndex1 = 1;
        this.isRefresh = item.bookId == this.$route.query.id;
        this.getList();
      } else {
        this.$toast(res.message);
      }
    },
    setPosNav() {
      let info = this.info;
      let posNavs = [{
        id: 1,
        name: '首页',
        pathName: 'index'
      }, {
        id: 2,
        name: '收藏夹'
      }];
      this.posNavs = posNavs;
    },
    jumpPage(key, params) {
      this.$gopage(key, params)
      this.status = false;
    },
    onDel(item) {
      MessageBox.confirm('确认删除该课件收藏？', '提示', {
        type: 'warning'
      }).then(() => {
        this.deleteFav(item)
      }).catch(() => {
        
      });
    },
    onClose() {
      if(this.isRefresh)
        this.$router.go(0)
    }
  }
}

</script>
<style lang="less" scoped>
@import '~styles/book/detail.less';

.layout-right {
  max-height: 70vh;
  min-height: 20vh;
  overflow-y: auto;

  // &::-webkit-scrollbar {
  //   width: 0;
  //   height: 0;
  //   background: transparent;
  // }
  .main {
    padding: 20px 0;
  }
}
</style>
